(() => {
  'use strict';

  if (window.__printoraLegalCleanup) return;
  window.__printoraLegalCleanup = true;

  const PATH = location.pathname || '';
  if (!PATH.includes('/policies/')) return;

  const PHONE = '01675 432 149';
  const EMAIL = 'orders@printora.co.uk';
  const ADDRESS = '27a Roman Way, Coleshill, B46 1HQ';
  const COMPANY = 'Printora Limited';
  const COMPANY_NO = '16047897';

  const tidy = (html) =>
    String(html || '')
      .replace(/\[Printora Limited\]/gi, COMPANY)
      .replace(/\[27a Roman Way,\s*Coleshill,\s*B46\s*1HQ\]/gi, ADDRESS)
      .replace(/\[0333\s*038\s*5008\]/gi, PHONE)
      .replace(/\[16047897\]/gi, `Company No. ${COMPANY_NO}`)
      .replace(/\[LINK TO REFUND POLICY\]/gi, '<a href="/policies/refund-policy">Refund Policy</a>')
      .replace(/\[LINK TO PRIVACY POLICY\]/gi, '<a href="/policies/privacy-policy">Privacy Policy</a>')
      .replace(/01675432111/g, PHONE)
      .replace(/0333\s*038\s*5008/g, PHONE)
      .replace(/any any circumstances/gi, 'any circumstances');

  const run = () => {
    document.querySelectorAll('.shopify-policy__body, .shopify-policy__container').forEach((node) => {
      if (node.dataset.pkLegalTidied === '1') return;
      const next = tidy(node.innerHTML);
      if (next !== node.innerHTML) node.innerHTML = next;
      node.dataset.pkLegalTidied = '1';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
